export default "__VITE_ASSET__DHoaKq_8__"